const Apple = ({
  width = 21,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4256 10.053C14.4467 12.323 16.417 13.0784 16.4388 13.088C16.4222 13.1413 16.124 14.1645 15.4008 15.2214C14.7756 16.1352 14.1267 17.0456 13.1046 17.0645C12.1002 17.083 11.7772 16.4689 10.6289 16.4689C9.481 16.4689 9.12218 17.0456 8.17143 17.083C7.18478 17.1204 6.43344 16.0949 5.80307 15.1845C4.51495 13.3222 3.53056 9.92207 4.85235 7.62694C5.50899 6.48717 6.68245 5.76542 7.95614 5.74692C8.92499 5.72844 9.83946 6.39873 10.4318 6.39873C11.0237 6.39873 12.135 5.59264 13.3032 5.71103C13.7923 5.73138 15.1652 5.90858 16.0467 7.19893C15.9757 7.24297 14.4086 8.15523 14.4256 10.053ZM12.538 4.47896C13.0618 3.8449 13.4144 2.96223 13.3182 2.08398C12.5632 2.11433 11.6502 2.58712 11.1086 3.22083C10.6232 3.78201 10.1982 4.68022 10.3129 5.54108C11.1544 5.60619 12.0142 5.11342 12.538 4.47896Z"
        fill="black"
      />
    </svg>
  );
};

export default Apple;
